// React context that exposes the Leaflet map instance to children of
// <ForecastMap/>. Future overlay layers (e.g. <ForecastRasterOverlay/>,
// <AirspaceLayer/>) read the map via useForecastMap() and add their Leaflet
// layer in a useEffect — they don't have to modify ForecastMap itself.

import { createContext, useContext } from 'react';

const ForecastMapContext = createContext(null);

export const ForecastMapProvider = ForecastMapContext.Provider;

export const useForecastMap = () => useContext(ForecastMapContext);

// A separate, small context for touch-interaction wiring (coarse-pointer flag +
// the map's toast/peek hooks). Kept separate from useForecastMap so layer
// components that read the bare map instance are unaffected. Defaults are no-ops
// so consumers work even if rendered outside the provider (e.g. tests).
const MapInteractionContext = createContext({ coarsePointer: false, showHint: () => {}, claimPeek: () => {} });

export const MapInteractionProvider = MapInteractionContext.Provider;

export const useMapInteraction = () => useContext(MapInteractionContext);

// True while the maplibre map is usable. After Map.remove() (which runs in the
// map component's LAYOUT-effect cleanup, i.e. BEFORE child layers' passive
// effect cleanups on route unmount) `map.style` is gone and any getLayer/
// removeLayer call throws — which blanks the whole app. Layer components must
// check this before touching the map in their cleanup.
export const mapAlive = (map) => !!(map && map.style);
